// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IU8G5","rootNoMargin":"styles_rootNoMargin__SPDUv"};